const OffersHelper = {
  // note that moment months are zero index so march ==2 - currently set to 1 for Feb testing
  isOfferActive: () => {
    const OfferActive = sessionStorage.getItem("OfferActive");
    return OfferActive === 'true';
  }
};

export default OffersHelper;
